import Vue3Sanitize from 'vue-3-sanitize';
import sanitizeHtml from 'sanitize-html';

const headingTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
const headingAttributes = {};
headingTags.forEach((tag) => {
  const defaults = sanitizeHtml.defaults.allowedAttributes[tag] || [];
  headingAttributes[tag] = [...defaults, 'id'];
});

const sanitizeOptions = {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat(['iframe']),
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    ...headingAttributes,
    a: [...(sanitizeHtml.defaults.allowedAttributes.a || []), 'class'],
    iframe: [
      'src',
      'width',
      'height',
      'frameborder',
      'allow',
      'title',
      'allowfullscreen',
    ],
  },
  allowedIframeHostnames: ['player.vimeo.com'],
};

export default function (app) {
  app.use(Vue3Sanitize, sanitizeOptions);
}
